import React from 'react';
import PropTypes from 'prop-types';
import IconHome from 'cccisd-icons/home3';
import IconUsers from 'cccisd-icons/users4';
import IconReading from 'cccisd-icons/reading';
import IconGraduation from 'cccisd-icons/graduation';
import IconNetworker from 'cccisd-icons/lan2';
import Header from 'cccisd-header';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;

const iconMap = {
    home: IconHome,
    users: IconUsers,
    reading: IconReading,
    graduation: IconGraduation,
    lan2: IconNetworker,
};

const NavBar = ({ className, noLogoLink }) => {
    let primaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'primaryNav').nav;
    } catch (e) {
        // meh, leave it empty
    }

    let secondaryNavLinks = [];
    try {
        secondaryNavLinks = Appdefs.navs
            .find(n => n.handle === 'secondaryNav')
            .nav.map(navItem => ({
                ...navItem,
                icon: navItem.icon && navItem.icon in iconMap ? iconMap[navItem.icon] : null,
            }));
    } catch (e) {
        // meh, leave it empty
    }

    return (
        <Header
            containerClassName={className}
            logoClassName={style.logoPlaceholder}
            primaryNavLinks={primaryNavLinks}
            secondaryNavLinks={secondaryNavLinks}
            showAlertAction={false}
            showHomeAction={false}
            {...(noLogoLink ? { logoLink: null } : {})}
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
    noLogoLink: false,
};

NavBar.propTypes = {
    className: PropTypes.string,
    noLogoLink: PropTypes.bool,
};

export default NavBar;
